import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import moment from "moment";
import ScoreboxModal from "components/scorebox-modal";
import { relativeTimeString } from "util/date";
import { NO_TEAM_IMG } from "config";

const fnMatchTypeIDToString = (fnMatchTypeID) => {
  if (fnMatchTypeID === 25) return "twcd";
  if (fnMatchTypeID === 26) return "twcj";
  if (fnMatchTypeID === 27) return "twcb";
  return "";
};

class Match extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showScoreboxModal: false,
      dateNow: moment.tz(moment(), moment.tz.guess()),
    };
    this.interval = null;
  }

  componentDidMount() {
    const { ftDateTimeUTC } = this.props;
    const dateNow = moment.tz(moment(), moment.tz.guess());
    const startDate = moment.tz(ftDateTimeUTC, "YYYY-MM-DD HH:mm:ss", "UTC");

    if (dateNow.isSameOrBefore(startDate)) {
      this.interval = setInterval(() => this.updateTime(), 1000); // every minute
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  updateTime() {
    this.setState({
      ...this.state,
      dateNow: moment.tz(moment(), moment.tz.guess()),
    });
  }

  openModal = () => {
    if (this.props.match && this.props.match.rounds) {
      this.setState({
        ...this.state,
        showScoreboxModal: true,
      });
    }
  };

  closeModal = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        showScoreboxModal: false,
      });
    }, 0);
  };

  render() {
    const {
      fnMatchTypeID,
      team1,
      team2,
      ftDateTimeUTC,
      fcArena,
      match,
      schedule,
    } = this.props;

    const statusNames = ["Unknown", "Finished", "Forfeit", "Void", "Replay", "Appealed"];

    const matchStatus = match !== null ? statusNames[match.league_match.fnMatchStatusTypeID] : "Finished";

    const { showScoreboxModal } = this.state;

    const dateNow = moment.tz(moment(), moment.tz.guess());
    const startDate = moment.tz(ftDateTimeUTC, "YYYY-MM-DD HH:mm:ss", "UTC");

    let classes = [
      "match",
      fnMatchTypeIDToString(fnMatchTypeID),
      match && match.rounds ? "has-scorebox" : "",
      matchStatus === "Void" ? "is-void" : "",
      matchStatus === "Forfeit" ? "is-forfeit" : "",
      matchStatus === "Replay" ? "is-replay" : "",
    ];
    let containerClasses = [
      "match--container",
      match && match.rounds ? "has-scorebox" : "",
    ];

    let homeTeam = team1;
    let homeTeamClasses = ["match--team", "home"];
    let homeTeamName;
    let homeTeamImgUrl;
    let homeTeamScores;

    let awayTeam = team2;
    let awayTeamClasses = ["match--team", "away"];
    let awayTeamName;
    let awayTeamImgUrl;
    let awayTeamScores;

    let details;
    let timer;

    if (matchStatus === "Void") {
      classes.push("void");
    }

    if (matchStatus === "Forfeit") {
      classes.push("forfeit");
    }

    if (homeTeam) {
      homeTeamName = homeTeam.fcTeamName;
      homeTeamImgUrl = homeTeam.fcImageURL;
    } else {
      homeTeamName = "---";
      homeTeamImgUrl = NO_TEAM_IMG;
    }

    if (awayTeam) {
      awayTeamName = awayTeam.fcTeamName;
      awayTeamImgUrl = awayTeam.fcImageURL;
    } else {
      awayTeamName = "---";
      awayTeamImgUrl = NO_TEAM_IMG;
    }

    const formatScore = (num) => {
      if (match.match_type.fnBasing) {
        const mins = Math.floor(num / 60);
        let secs = num - mins * 60;
        secs = secs < 10 ? `0${secs}` : secs;
        return `${mins}:${secs}`;
      }
      return num;
    };

    if (match && match.rounds) {
      homeTeamScores = (
        <div className="match--team--scores">
          {match.rounds.map((round) => {
            let classes = ["match--team--score"];
            const roundWinner = (parseInt(round.fnTeamWinner, 10) === 1 ? homeTeam.fnTeamID : awayTeam.fnTeamID);
            if (roundWinner === homeTeam.fnTeamID) {
              classes.push("winner");
            }

            return (
              <div key={round.fnMatchRoundID} className={classes.join(" ")}>
                {formatScore(round.fnTeam1Score)}
              </div>
            );
          })}
        </div>
      );

      awayTeamScores = (
        <div className="match--team--scores">
          {match.rounds.map((round) => {
            let classes = ["match--team--score"];
            const roundWinner = (parseInt(round.fnTeamWinner, 10) === 1 ? homeTeam.fnTeamID : awayTeam.fnTeamID);
            if (roundWinner === awayTeam.fnTeamID) {
              classes.push("winner");
            }

            return (
              <div key={round.fnMatchRoundID} className={classes.join(" ")}>
                {formatScore(round.fnTeam2Score)}
              </div>
            );
          })}
        </div>
      );
    }

    if (match) {
      classes.push("has-winner");

      if (match.league_match.winner === homeTeam.fnTeamID) {
        homeTeamClasses.push("winner");
      } else if (match.league_match.winner === awayTeam.fnTeamID) {
        awayTeamClasses.push("winner");
      }
    } else {
      details = (
        <div className="match--details">
          <div className="match--details--date">
            {startDate.clone().tz(dateNow.tz()).format("h:mm A")}
          </div>
          <div className="match--details--arena">{fcArena}</div>
        </div>
      );
    }

    if (dateNow.isSameOrBefore(startDate)) {
      timer = (
        <div className="match--timer">
          <div className="match--timer--starts-in">Starts in</div>
          <div className="match--timer--value">
            {relativeTimeString(moment.duration(startDate.diff(dateNow)))
              .split(",")
              .map((value, i) => (
                <div key={i}>{value}</div>
              ))}
          </div>
        </div>
      );
    } else {
      if (matchStatus === "Void") {
        timer = (
          <div className="match--timer">
            <div className="match--void">VOID</div>
          </div>
        );
      } else if (matchStatus === "Forfeit") {
        timer = (
          <div className="match--timer">
            <div className="match--forfeit">FORFEIT</div>
          </div>
        );
      } else if (!match) {
        timer = (
          <div className="match--timer">
            <div>Waiting for scores...</div>
          </div>
        );
      }
    }

    return (
      <div className={classes.join(" ")}>
        <div className={containerClasses.join(" ")} onClick={this.openModal}>
          <div className="match--inner">
            <div className="match--type">
              {fnMatchTypeIDToString(fnMatchTypeID)}
            </div>
            <div className={homeTeamClasses.join(" ")}>
              <div className="match--team--name">{homeTeamName}</div>
              <div className="match--team--img">
                <img
                  src={homeTeamImgUrl}
                  alt={homeTeamName}
                  width="40"
                  height="40"
                />
              </div>
              {homeTeamScores}
            </div>
            {details}
            <div className={awayTeamClasses.join(" ")}>
              {awayTeamScores}
              <div className="match--team--img">
                <img
                  src={awayTeamImgUrl}
                  alt={awayTeamName}
                  width="40"
                  height="40"
                />
              </div>
              <div className="match--team--name">{awayTeamName}</div>
            </div>
          </div>
          {window.location.search === "?admin=1" && (
            <div className="match--admin-schedule">
              !game {schedule.fnScheduleID}
            </div>
          )}
        </div>
        {timer}
        {ReactDOM.createPortal(
          <ScoreboxModal
            active={showScoreboxModal}
            closeModal={this.closeModal}
            type={fnMatchTypeIDToString(fnMatchTypeID)}
            rounds={match ? match.rounds : []}
            match={match}
          />,
          document.body
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(Match);



// WEBPACK FOOTER //
// ./src/components/match/match.js